import { classNames } from '@app/utils/classes'
import { Popover, Transition } from '@headlessui/react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { FC, Fragment } from 'react'
import { GrDocumentCsv, GrDownload } from 'react-icons/gr'
import { VscJson } from 'react-icons/vsc'

type FeedButtonProps = {
  onJsonClick?(): void
  onCSVClick?(): void
  className?: string
  csvTitle?: string
  jsonTitle?: string
}

// download csv data or json data
export const DownloadPopover: FC<FeedButtonProps> = ({
  className,
  onCSVClick,
  onJsonClick,
  csvTitle,
  jsonTitle,
}) => {
  const { t } = useTranslation('dashboard')

  const exportTitle = t('export-data')

  return (
    <Popover className='relative'>
      {({ open }) => (
        <>
          <Popover.Button
            title={exportTitle}
            type={'button'}
            className={classNames(className || '', open ? 'text-blue-600' : '')}
          >
            <span className='sr-only'>{exportTitle}</span>
            <GrDownload className={`grIcon`} />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter='transition ease-out duration-200'
            enterFrom='opacity-0 translate-y-1'
            enterTo='opacity-100 translate-y-0'
            leave='transition ease-in duration-150'
            leaveFrom='opacity-100 translate-y-0'
            leaveTo='opacity-0 translate-y-1'
          >
            <Popover.Panel className='absolute z-10 transform max-w-sm'>
              <div className='relative px-3 rounded shadow-xl flex space-x-2 bg-gray-300 dark:bg-gray-800'>
                <Popover.Button
                  onClick={onCSVClick}
                  title={csvTitle}
                  type={'button'}
                  className={className}
                >
                  <>
                    <span className='sr-only'>{csvTitle}</span>
                    <GrDocumentCsv className='grIcon' />
                  </>
                </Popover.Button>
                <Popover.Button
                  onClick={onJsonClick}
                  title={jsonTitle}
                  type={'button'}
                  className={className}
                >
                  <>
                    <span className='sr-only'>{jsonTitle}</span>
                    <VscJson className='grIcon' />
                  </>
                </Popover.Button>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  )
}
